var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1311_6713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3835 0 0 5.3835 0 12C0 18.6165 5.3835 24 12 24C18.6165 24 24 18.6165 24 12C24 5.3835 18.6165 0 12 0ZM12 23C5.9345 23 1 18.0655 1 12C1 5.9345 5.9345 1 12 1C18.0655 1 23 5.9345 23 12C23 18.0655 18.0655 23 12 23Z",
    fill: "#031434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6465 6.6465L12 11.293L7.3535 6.6465L6.6465 7.3535L11.293 12L6.6465 16.6465L7.3535 17.3535L12 12.707L16.6465 17.3535L17.3535 16.6465L12.707 12L17.3535 7.3535L16.6465 6.6465Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1311_6713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCancelIcon);
export default __webpack_public_path__ + "static/media/circle_cancel_icon.499c75d28825ad7e71705930b3da7b51.svg";
export { ForwardRef as ReactComponent };